import { type Token } from '@app/client/common/structs';
import { useAuthTokens, UserType, useUser } from '@app/store/zustand';

import { validateAuthTokens } from './utilities';

export function useTokens() {
    const { setUserType } = useUser();
    const { setAuthTokens } = useAuthTokens();

    async function setTokens(tokens: Token, accountType?: UserType) {
        await setAuthTokens(tokens);
        validateAuthTokens();

        if (accountType === UserType.Draft) {
            setUserType(accountType);
        }
    }

    return {
        setTokens,
    };
}
